import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, input, signal, WritableSignal } from '@angular/core';
import { RouterModule } from '@angular/router';
import { select } from '@ngxs/store';
import { AnimateModule, WwwAppState } from '@pro-connect/shared';
import { ToastrService } from 'ngx-toastr';
import { IProExperienceEvent } from '../../models/pro-experience-event';

@Component({
  selector: 'app-pro-exp-con-red-txt',
  templateUrl: './pro-exp-con-red-txt.component.html',
  styleUrls: ['./pro-exp-con-red-txt.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, RouterModule, AnimateModule],
})
export class ProExpConRedTxtComponent {
  protected readonly _toastrService: ToastrService = inject(ToastrService);
  public readonly user = select(WwwAppState.user);
  public trainingDetails = input.required<IProExperienceEvent | null>();
  public arrayToDisplay: WritableSignal<string[]> = signal([]);

  public ngOnInit(): void {
    // Temporary solution, move to pipe to divide to two equal columns of text
    setTimeout(() => {
      const middle = Math.round(String(this.trainingDetails()?.additional_description).length / 2);
      let index = null;
      if (this.trainingDetails()?.additional_description) {
        for (let i = middle; i < String(this.trainingDetails()?.additional_description).length; i++) {
          if (String(this.trainingDetails()?.additional_description)[i] === ' ') {
            index = i;
            break;
          }
        }
        this.arrayToDisplay.set([
          String(this.trainingDetails()?.additional_description).slice(0, Number(index)),
          String(this.trainingDetails()?.additional_description).slice(
            Number(index),
            String(this.trainingDetails()?.additional_description).length,
          ),
        ]);
      } else {
        this.arrayToDisplay.set([]);
      }
    }, 200);
  }
}
